/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
export type TVShowEpisodeState = "available" | "hidden" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type Epg_viewer$ref: FragmentReference;
export type Epg_viewer = {|
  +episodes: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +startDate: ?string,
        +endDate: ?string,
        +title: ?string,
        +state: TVShowEpisodeState,
      |}
    |}>
  |},
  +$refType: Epg_viewer$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "Epg_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "day",
      "type": "String",
      "defaultValue": null
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "episodes",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "day",
          "variableName": "day",
          "type": "String"
        },
        {
          "kind": "Literal",
          "name": "first",
          "value": -1,
          "type": "Int"
        },
        {
          "kind": "Literal",
          "name": "showAll",
          "value": true,
          "type": "Boolean"
        }
      ],
      "concreteType": "TVShowEpisodeConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "TVShowEpisodeEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "TVShowEpisode",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "id",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "startDate",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "endDate",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "title",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "state",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '61ec9cc619ede7aa48b254d826da673d';
module.exports = node;



// WEBPACK FOOTER //
// src/components/epg/__generated__/Epg_viewer.graphql.js